// Bifurcated Five9 / LiveHelpNow Chat (optimized)

// ---------------------------------------------------------------------------
// Shared SVG icons (previously duplicated inline in multiple template strings)
// ---------------------------------------------------------------------------
const CHAT_BUBBLE_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"><path d="M12 3c5.514 0 10 3.592 10 8.007 0 4.917-5.145 7.961-9.91 7.961-1.937 0-3.383-.397-4.394-.644-1 .613-1.595 1.037-4.272 1.82.535-1.373.723-2.748.602-4.265-.838-1-2.025-2.4-2.025-4.872-.001-4.415 4.485-8.007 9.999-8.007zm0-2c-6.338 0-12 4.226-12 10.007 0 2.05.738 4.063 2.047 5.625.055 1.83-1.023 4.456-1.993 6.368 2.602-.47 6.301-1.508 7.978-2.536 1.418.345 2.775.503 4.059.503 7.084 0 11.91-4.837 11.91-9.961-.001-5.811-5.702-10.006-12.001-10.006zm-3.5 10c0 .829-.671 1.5-1.5 1.5-.828 0-1.5-.671-1.5-1.5s.672-1.5 1.5-1.5c.829 0 1.5.671 1.5 1.5zm3.5-1.5c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5c.829 0 1.5-.671 1.5-1.5s-.671-1.5-1.5-1.5zm5 0c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5c.829 0 1.5-.671 1.5-1.5s-.671-1.5-1.5-1.5z"/></svg>`;

const CLOSE_ICON_SVG = `<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="xmark" class="svg-icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"></path></svg>`;

// used for the floating chat launcher, the two prechat forms, and the default (no-prechat) container markup - all four were byte-identical in the original
const chatToggleButtonHtml = `<button class="chat-toggle-btn">${CLOSE_ICON_SVG}</button>`;

// ---------------------------------------------------------------------------
// Markup/CSS
// ---------------------------------------------------------------------------
const floatingChatBtnHtml = `
  <style>
    .chat-floating-btn-container {
      display: none;
      height: 60px;
      width: 60px;
      position: fixed;
      bottom: 20px;
      right: 20px;
      z-index: 99999;
      opacity: 0;
      transition: opacity 250ms ease-in-out 0s;
    }
    .chat-floating-btn-container.is--visible {
      display: block;
      opacity: 1;
    }
    .chat-floating-btn-container .chat-floating-btn {
      height: 60px;
      width: 60px;
      color: #fff;
      background-color: #D8F793;
      border-radius: 30px;
      border: 0;
      box-shadow: rgb(0 0 0 / 10%) 0px 1px 6px, rgb(0 0 0 / 20%) 0px 2px 24px;
      transition: box-shadow 200ms ease-in-out 0s;
      cursor: pointer;
    }
    .chat-floating-btn-container .chat-floating-btn svg {
      color: inherit;
    }
    .chat-floating-btn-container .chat-floating-btn:hover {
      box-shadow: 0 0 15px rgba(0,0,0,.5);
    }
  </style>
  <button type='button' class='chat-floating-btn' aria-label="live chat">
    ${CHAT_BUBBLE_ICON_SVG}
  </button>
`;

const chatContainerCss = `
  .chat-container {
    height: 0;
    width: 0;
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 99999;
    border-radius: 30px;
    overflow: hidden;
    background-color: transparent;
    transition: height 200ms ease-in-out 0s;
  }
  .chat-container.is--visible {
    height: 600px;
    width: 100%;
    max-width: 400px;
    background-color: #fff;
    box-shadow: 0 0 15px rgba(0,0,0,.5);
  }
  .chat-container::after {
    display: block;
    height: 100px;
    width: 100px;
    position: absolute;
    content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24"><path fill="currentColor" d="M12 3c5.514 0 10 3.592 10 8.007 0 4.917-5.145 7.961-9.91 7.961-1.937 0-3.383-.397-4.394-.644-1 .613-1.595 1.037-4.272 1.82.535-1.373.723-2.748.602-4.265-.838-1-2.025-2.4-2.025-4.872-.001-4.415 4.485-8.007 9.999-8.007zm0-2c-6.338 0-12 4.226-12 10.007 0 2.05.738 4.063 2.047 5.625.055 1.83-1.023 4.456-1.993 6.368 2.602-.47 6.301-1.508 7.978-2.536 1.418.345 2.775.503 4.059.503 7.084 0 11.91-4.837 11.91-9.961-.001-5.811-5.702-10.006-12.001-10.006zm-3.5 10c0 .829-.671 1.5-1.5 1.5-.828 0-1.5-.671-1.5-1.5s.672-1.5 1.5-1.5c.829 0 1.5.671 1.5 1.5zm3.5-1.5c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5c.829 0 1.5-.671 1.5-1.5s-.671-1.5-1.5-1.5zm5 0c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5c.829 0 1.5-.671 1.5-1.5s-.671-1.5-1.5-1.5z"/></svg>');
    top: calc(50% - 50px);
    left: calc(50% - 50px);
    transform: scale(.5);
    opacity: 0.2;
    animation: chat-animate 1.5s infinite;
  }
  .chat-container::before {
    display: block;
    height: 100px;
    width: 100px;
    position: absolute;
    content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24"><path fill="currentColor" d="M12 3c5.514 0 10 3.592 10 8.007 0 4.917-5.145 7.961-9.91 7.961-1.937 0-3.383-.397-4.394-.644-1 .613-1.595 1.037-4.272 1.82.535-1.373.723-2.748.602-4.265-.838-1-2.025-2.4-2.025-4.872-.001-4.415 4.485-8.007 9.999-8.007zm0-2c-6.338 0-12 4.226-12 10.007 0 2.05.738 4.063 2.047 5.625.055 1.83-1.023 4.456-1.993 6.368 2.602-.47 6.301-1.508 7.978-2.536 1.418.345 2.775.503 4.059.503 7.084 0 11.91-4.837 11.91-9.961-.001-5.811-5.702-10.006-12.001-10.006zm-3.5 10c0 .829-.671 1.5-1.5 1.5-.828 0-1.5-.671-1.5-1.5s.672-1.5 1.5-1.5c.829 0 1.5.671 1.5 1.5zm3.5-1.5c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5c.829 0 1.5-.671 1.5-1.5s-.671-1.5-1.5-1.5zm5 0c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5c.829 0 1.5-.671 1.5-1.5s-.671-1.5-1.5-1.5z"/></svg>');
    top: calc(50% - 50px);
    left: calc(50% - 50px);
    transform: scale(.5);
    opacity: 0.2;
    animation: chat-animate 1.5s infinite;
    animation-delay: -0.75s;
  }
  @keyframes chat-animate {
    to {
      transform: scale(1.8);
      opacity: 0
    }
  }
  .chat-container .f9ChatEmbedded {
    height: 100%;
    top: 0;
    border: 0;
    border-top: 3px solid #65758E;
    box-shadow: none;
  }
  .chat-container .chat-toggle-btn {
    position: absolute;
    height: 45px;
    width: 45px;
    line-height: 45px;
    padding: 0;
    top: 10px;
    right: 10px;
    background-color: #4B5DFF;
    color: #fff;
    z-index: 99999;
    border: 0;
    border-radius: 50%;
    transition: background-color 200ms ease-in-out 0s, color 200ms ease-in-out 0s;
  }
  .chat-container .chat-toggle-btn:hover {
    background-color: #D8F793;
    color: #333;
    box-shadow: 0 0 15px rgba(0,0,0,.3);
  }
  .chat-container .chat-toggle-btn .svg-icon {
    margin-top: -3px;
    height: 18px;
    width: 18px;
    vertical-align: middle;
    box-sizing: content-box;
  }
  @media (min-width: 576px) {
    .chat-container {
      bottom: 20px;
      right: 20px;
    }
  }
  @media (max-height: 710px) {
    .chat-container {
      bottom: 0;
      right: 0;
    }
    .chat-container.is--visible {
      height: 100%;
    }
    .chat-container .f9ChatEmbedded {
      height: 100%;
    }
  }
`;

const prechatFormCss = `
  #pre-chat-form-wrapper {
    position: relative;
    padding: 20px;
    padding-top: 60px;
    background: #fff;
    z-index: 1;
    overflow-y: scroll;
    height: 100%;
  }
  #vivr-iframe {
    position: relative;
    z-index: 1;
    height: 100%;
  }
  .pre-chat-header {
    text-align: center;
    margin-bottom: 30px;
  }
  .pre-chat-title {
    font-weight: 600;
    font-size: 36px;
  }
  .chat-prechat-form {
    margin: 0;
    padding: 0;
  }
  .pre-chat-label {
    display: block;
    margin: 0;
    margin-bottom: 15px;
  }
  .pre-chat-label .invalid-text {
    display: none;
    font-size: .9em;
    color: #fb4f16;
  }
  .pre-chat-label.is-invalid .invalid-text {
    display: inline-block;
  }
  .pre-chat-text-label {
    margin: 0;
    margin-bottom: 3px;
    font-size: .9rem;
  }
  .pre-chat-field {
    width: 100%;
    appearance: none;
    position: relative;
    padding: 5px 10px;
    background: #fff;
    border: 1px solid #cccccc;
    min-height: 38px;
    line-height: inherit;
    border-radius: 7px;
  }
  .pre-chat-field.is-invalid {
    border-color: #fb4f16;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right calc(.375em + .1875rem) center;
    background-size: calc(.75em + .375rem) calc(.75em + .375rem);
  }
  .pre-chat-field.is-invalid:focus-visible {
    border-color: #ccc;
  }

  .pre-chat-language,
  .pre-chat-radio-btn-group {
    display: flex;
    margin-bottom: 5px;
  }
  .pre-chat-language .language-btn,
  .pre-chat-radio-btn-group .radio-btn {
    width: calc(50% - 5px);
  }
  .pre-chat-language .language-btn:first-child,
  .pre-chat-radio-btn-group .radio-btn:first-child {
    margin-right: 10px;
  }
  .pre-chat-language .language-btn input[type='radio'],
  .pre-chat-radio-btn-group .radio-btn input[type='radio'] {
    opacity: 0;
    position: fixed;
    width: 0;
  }
  .pre-chat-language .language-btn label,
  .pre-chat-radio-btn-group .radio-btn label {
    display: inline-block;
    padding: 5px 5px;
    width: 100%;
    text-decoration: none;
    font-weight: 600;
    color: #458cca;
    border: 1px solid #458cca;
    background-color: transparent;
    border-radius: 4px;
    -webkit-transition: all 100ms ease-in-out;
    transition: all 100ms ease-in-out;
    text-align: center;
  }
  .pre-chat-language .language-btn label:hover,
  .pre-chat-radio-btn-group .radio-btn label:hover {
    color: #ffffff;
    background-color: #458cca;
    cursor: pointer;
  }
  .pre-chat-language .language-btn input[type='radio']:checked+label,
  .pre-chat-radio-btn-group .radio-btn input[type='radio']:checked+label {
    color: #ffffff;
    background-color: #458cca;
  }

  .pre-chat-start-btn {
    font-family: inherit;
    font-size: inherit;
    display: inline-block !important;
    margin: 10px auto 0 auto !important;
    padding: 10px 8px !important;
    width: 100% !important;
    text-decoration: none !important;
    font-weight: 600 !important;
    line-height: 1.6 !important;
    color: #fff !important;
    border: 0 !important;
    background-color: #4B5DFF !important;
    background-image: none !important;
    border-radius: 7px !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
  .pre-chat-start-btn:hover {
    background-color: #364AFF !important;
  }
  @media (min-width: 576px) {
    #pre-chat-form-wrapper {
      padding: 40px;
      padding-top: 60px;
    }
  }

`;

const liveHelpChatCss = `
  [class*="lhn-chat-container-chatbox-classic"] {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .lhn-chat-container-chatbox-classic-header {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
`;

// html for the prechat box
const preFive9ChatFormHtml = (emailValue = "") => {
  return `
    ${chatToggleButtonHtml}
    <div id="pre-chat-form-wrapper">
      <style>${prechatFormCss}</style>

      <div class="pre-chat-header">
        <h4 class="pre-chat-title">Welcome!</h4>
        <p class="pre-chat-texty mb-0">Before we get started, please fill out the details below.</p>
      </div>
      <form id="pre-chat-form" class='chat-prechat-form'>
        <label class="pre-chat-label">
          <p class="pre-chat-text-label">Select Language <em class="invalid-text">- is required</em></p>
          <div class="pre-chat-language">
            <div class="language-btn">
              <input class="required" type="radio" id="language-english" name="language" value="english" required />
              <label for="language-english">English</label>
            </div>
            <div class="language-btn">
              <input class="required" type="radio" id="language-spanish" name="language" value="spanish" required />
              <label for="language-spanish">Spanish</label>
            </div>
          </div>
        </label>
        <label class="pre-chat-label">
          <p class="pre-chat-text-label">Email Address <em class="invalid-text">- is required</em></p>
          <input class="pre-chat-field required" type="email" name="email" aria-label="text email" value="${emailValue}" />
        </label>
        <button class='pre-chat-start-btn' type='button'>Start Chat</button>
      </form>
    </div>
    <iframe id="vivr-iframe" style="display:none;" width="100%" height="600" scrolling="no"></iframe>
  `;
};

// html for the prechat box for bifurcated chat flow
const preBifurcatedChatFormHtml = `
  ${chatToggleButtonHtml}
  <div id="pre-chat-form-wrapper">
    <style>${prechatFormCss}</style>

    <div class="pre-chat-header">
      <h4 class="pre-chat-title">Welcome!</h4>
      <p class="pre-chat-texty mb-0">Which team are you trying to reach?</p>
    </div>
    <form id="pre-chat-form" class='chat-prechat-form'>
      <label class="pre-chat-label">
        <p class="pre-chat-text-label mb-2"><!--Which best describes you?--> &nbsp;<em class="invalid-text">Which best describes you? Click the button below.</em></p>
        <div class="pre-chat-radio-btn-group">
          <div class="radio-btn">
            <input class="required" type="radio" id="chat-support" name="chatRoute" value="support" required />
            <label for="chat-support">Support</label>
          </div>
          <div class="radio-btn">
            <input class="required" type="radio" id="chat-sales" name="chatRoute" value="sales" required />
            <label for="chat-sales">Sales</label>
          </div>
        </div>
      </label>
      <!--
      <label class="pre-chat-label">
        <p class="pre-chat-text-label">Email Address &nbsp;<em class="invalid-text">(This is required)</em></p>
        <input class="pre-chat-field required" type="email" name="email" aria-label="text email" />
      </label>
      -->
      <button class='pre-chat-start-btn' type='button'>Start Chat</button>
    </form>
  </div>
`;

// custom text/messaging and translation
const messagerCustomText = {
  en: {}, // enter English custom text if any
  es: {
    formErrorInvalidEmail: "El correo electrónico no es válido",
    formErrorInvalidQuestion: "La pregunta no es válida",
    formErrorInvalidName: "El nombre no es válido",
    headerText: "¿Cómo podemos ayudar?",
    inputPlaceholder: "Escriba un mensaje...",
    inputPlaceholderBlocked: "Escriba un mensaje...",
    locationNotSupported:
      "Su navegador no admite los servicios de ubicación o están desactivados. Por favor, escriba su ubicación.",
    locationServicesDenied:
      "Este sitio web no puede acceder a su ubicación. Permita el acceso en la configuración o escriba su ubicación.",
    shareLocation: "Compartir Ubicación",
    uploadDocument: "Adjuntar Archivo",
    uploadPhoto: "Agregar Imagen",
    soundNotification: "Habilitar Sonido",
    printTranscipt: "Imprimir Transcripción",
    startConversation: "Iniciar Conversación",
    conversationTerminated: "La conversación ha terminado.",
    cancelConversation: "Cancelar",
    closeConfirmationMessage:
      "¿Está seguro de que quiere terminar la conservación?",
    closeConfirmationCancel: "Cancelar",
    closeConfirmationEndChat: "Terminar la Conversación",
    welcomeHeader: "Bienvenido",
    welcomeDescription:
      "Antes de comenzar, por favor complete los detalles que se encuentran más abajo.",
    languageContinue: "Continuar",
    languageCancel: "Cancelar",
    afterHoursHelpText: "Fuera del horario laboral",
    emailContentLabel: "Contenido",
    afterHoursEmailHelpText:
      "Fuera del horario laboral, el formulario de correo electrónico está disponible",
    emailContentPlaceholder: "Contenido...",
    outOfBusinessHoursMessageTitle: "Fuera del horario laboral",
    afterHoursEmailSentSuccess: "¡Éxito!",
    afterHoursEmailSentMessage: "El correo electrónico ha sido enviado.",
    afterHoursEmailModalClose: "Cerrar",
    afterHoursStartNew: "Iniciar Nuevo",
    afterHoursSendEmail: "Enviar Correo Electrónico",
    afterHoursSendEmailCancel: "Cancelar",
    chatEndedMessage: "Su sesión de conversación ha terminado",
    downloadTranscript: "Descargar Transcripción",
    clearHistory: "Borrar Historial",
    clearHistoryMessage: "Su historial se borrará en {minutos}",
    startNewChat: "Iniciar Nueva Conversación",
    closeWindow: "Cerrar Ventana",
    endChatconfirmationHeader: "Terminar Conversación",
    isRequiredText: "es obligatorio",
    isTypingText: "está escribiendo",
    areTypingText: "están escribiendo",
    unknownUser: "Usuario Desconocido",
    startSurvey: "Iniciar Encuesta",
    optionalText: "Texto Opcional",
    postChatSurveyHeaderText:
      "Texto de Encabezado de la Encuesta de Publicación Posterior a la Conversación",
    postChatSurveyLabelText:
      "Texto de Etiqueta de la Encuesta Posterior a la Conversación",
    postChatSurveyInputPlaceHolderText:
      "Texto de Marcador de Posición de Entrada de Encuesta Posterior a la Conversación",
    postChatSurveyCancelButtonText: "Cancelar",
    postChatSurveySubmitButtonText: "Enviar",
  },
};

// custom system messaging and translation
const systemMessages = {
  en: {}, // enter English custom text if any
  es: {
    conversationCreated: "Gracias por contactarnos.",
    participantAccepted: "Usted ha sido conectado con un agente.",
    participantJoined: "Un participante se ha unido a la conversación.",
    participantLeft: "Un participante ha abandonado la conversación.",
    transferredToParticipant: "La conversación ha sido transferida a {name}.",
    transferredToGroup:
      "Esa conversación ha sido transferida al grupo {group}.",
    conversationTerminated: "La conversación ha terminado.",
  },
};

// return capture fields depending if email needs to be collected
const captureFields = (lang, collectEmail = true) => {
  const defaultFields = [
    {
      k: "name",
      l: `${lang === "es" ? "Nombre" : "Name"}`,
      p: `${lang === "es" ? "Introduce tu nombre" : "Enter your name"}`,
    },
    {
      k: "Phone",
      l: `${lang === "es" ? "Teléfono" : "Phone"}`,
      p: `${lang === "es" ? "Introduce tu número de teléfono" : "Enter your phone number"}`,
    },
    {
      k: "Question",
      l: `${lang === "es" ? "Pregunta" : "Question"}`,
      p: `${lang === "es" ? "¿En qué podemos ayudarte hoy?" : "What can we help you with today?"}`,
    },
  ];

  // collect only on marketing website
  const emailField = {
    k: "email",
    l: `${lang === "es" ? "Correo Electrónico" : "Email Address"}`,
    p: `${lang === "es" ? "Introduce tu correo electrónico" : "Enter your email"}`,
  };

  if (collectEmail) {
    defaultFields.splice(1, 0, emailField);
  }

  return defaultFields;
};

// mapping chat profile and domains
const chatProfiles = [
  {
    profile: "Chat_U", // default profile if domain is not listed
    domains: null,
  },
  {
    profile: "VIVR",
    domains: [
      "login.certus.com",
      "americansafetycouncil.com",
      "amersc.com",
      "course.uceusa.com",
      "fusion.certus.com",
      "home.uceusa.com",
      "myaccount.uceusa.com",
    ],
  },
  {
    profile: "Chat_AAA",
    domains: ["aaadriverprogram.com"],
  },
  {
    profile: "Chat_DS",
    domains: [
      "delawaredriver.com",
      "help.americansafetycouncil.com",
      "123driving.com",
      "adischool.com",
      "californiadriveredcourse.com",
      "trafficschooltogo.com",
      "delawaredriver.com",
      "dmvflorida.org",
      "firsttimedriver.com",
      "floridaboatingcourse.com",
      "floridadrivingrecord.com",
      "floridafuntrafficschool.com",
      "floridaonlinetrafficschool.com",
      "indianadriver.com",
      "joshuaslaw.com",
      "maturedrivercourse.com",
      "michigandriverimprovement.com",
      "missourionlinedriverimprovement.com",
      "oklahomadriver.com",
      "onlinedefensivedriving.com",
      "onlinetraffic.com",
      "safemotorist.com",
      "stateofflorida.com",
      "teendrivereducation.com",
      "tennesseeonlinetrafficschool.com",
      "texasadultdriver.com",
      "texasdrivingschool.com",
      "trafficschooltogo.com",
      "virginiaonlinedriverimprovement.com",
    ],
  },
  {
    profile: "Chat_NYSC",
    domains: ["newyorksafetycouncil.com"],
  },
  {
    profile: "Chat_PS",
    domains: [
      "floridaparentingclass.com",
      "floridainsurancelicense.com",
      "floridaonlinecosmetology.com",
      "floridaonlinetattoolicense.com",
      "ncinsurancelicense.com",
    ],
  },
  {
    profile: "Chat_SS",
    domains: [
      "bassetcertification.org",
      "cannabiseducationcenter.com",
      "efoodcard.com",
      "efoodhandlers.com",
      "foodhandlercardonline.com",
      "illinoisbassetcertification.com",
      "sellerserveronline.com",
      "tabccertificationprogram.com",
      "tabctraining.org",
      "washingtonalcoholtraining.com",
    ],
  },
  {
    profile: "Chat_WS",
    domains: [
      "abcosha.com",
      "agrilifeirrigation.com",
      "certus.com",
      "iecoshatraining.com",
      "oshacampusonline.com",
      "oshaeducationcenter.com",
      "usfosha.com",
      "ustoperatortraining.com",
      "verify.uceusa.com",
    ],
  },
];

// Grouped static config
const CHAT_CONFIG = {
  five9: {
    scriptUrl:
      "https://cdn.prod.us.five9.net/static/stable/chat/wrapper/index.js",
    vivrBaseUrl:
      "https://api.five9.com/ivr/1/128193/campaigns/300000000000341/new_ivr_session",
    callbackUrl:
      "https://storage.googleapis.com/quickassist/customers/AmericanSafetyCouncil/realtimetranslation/errorpage.html",
  },
};

// ---------------------------------------------------------------------------
// Shared regex constants (single source of truth so the anchored/unanchored
// versions can't drift out of sync with each other)
// ---------------------------------------------------------------------------
const EMAIL_PATTERN_SOURCE = String.raw`(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))`;
// anchored - the whole field value must be nothing but an email (form validation)
const EMAIL_REGEX = new RegExp(`^${EMAIL_PATTERN_SOURCE}$`);
// unanchored - pulls an email out of a larger string, e.g. "Jane Doe (jane@example.com)"
const EMAIL_PATTERN = new RegExp(EMAIL_PATTERN_SOURCE);
const PHONE_REGEX = /[(]?\d{3}[)]?\s?-?\s?\d{3}\s?-?\s?\d{4}/;

// Utility: Convert FormData to a plain object
function getFormDataObject(form) {
  return Object.fromEntries(new FormData(form));
}

// Utility to create chat container and style
function createChatContainer({
  id,
  className,
  innerHTML,
  styleId,
  styleContent,
}) {
  let div = document.getElementById(id);
  if (!div) {
    div = document.createElement("div");
    div.id = id;
    div.setAttribute("class", className);
    div.innerHTML = innerHTML;
    document.body.appendChild(div);
  }
  let style = document.getElementById(styleId);
  if (!style) {
    style = document.createElement("style");
    style.id = styleId;
    style.innerHTML = styleContent;
    document.body.appendChild(style);
  }
  return { container: div, style };
}

// Attaches `handler` for `event`, first removing any prior identical
// registration - safe to call repeatedly across re-initializations without
// stacking duplicate listeners. No-op if `el` doesn't exist.
function bindOnce(el, event, handler, useCapture = true) {
  if (!el) return;
  el.removeEventListener(event, handler, useCapture);
  el.addEventListener(event, handler, useCapture);
}

// ---------------------------------------------------------------------------
// Shared form-field validation
// ---------------------------------------------------------------------------
// Validates a single field per its type, toggles the invalid-state classes on
// both the field and its wrapping label, and returns whether it's valid.
// Used by both blur-time and submit-time validation so the two don't drift
// out of sync with each other.
function validateField(field) {
  const label = field.closest(".pre-chat-label");
  let isValid;

  if (field.type === "email") {
    isValid = EMAIL_REGEX.test(field.value);
  } else if (field.type === "tel") {
    isValid = PHONE_REGEX.test(field.value);
  } else if (field.type === "radio") {
    const selectedRadio = document.querySelector(
      `input[name="${field.name}"]:checked`,
    );
    isValid = Boolean(selectedRadio?.value?.trim());
  } else {
    isValid = Boolean(field.value?.trim());
  }

  field.classList.toggle("is-invalid", !isValid);
  label?.classList.toggle("is-invalid", !isValid);

  return isValid;
}

function validateOnBlur(theForm) {
  if (!theForm) return false;

  const fields = theForm.querySelectorAll(".required");
  fields.forEach((field) => {
    // dataset marker avoids stacking duplicate blur listeners across repeat
    // calls (this form gets re-initialized, e.g. after a chat session ends)
    if (field.dataset.blurValidationBound === "true") return;
    field.dataset.blurValidationBound = "true";
    field.addEventListener("blur", () => validateField(field), true);
  });
}

function isPreChatValid(theForm) {
  if (!theForm) return false;

  const fields = theForm.querySelectorAll(".required");
  let isFormValid = true;
  fields.forEach((field) => {
    if (!validateField(field)) isFormValid = false;
  });

  return isFormValid;
}

const f9chat = {
  chatScript: document.getElementById("bifurcated_chat"),
  userDetails: document.querySelector(".user-bar .username"),
  userEmail: "",
  preChatForm: null,
  domain: "certus.com", // default for localhost development
  profile: "Chat_U", // default chat profile if domain is not mapped to a chat profile
  useFloatingBtn: false,
  usePreChatForm: false,
  collectEmail: true,
  chatContainer: null,
  chatWidgetStyle: null,
  chatFloatingBtnContainer: null,
  chatToggleButton: null,
  chatInitialized: false,

  init: () => {
    f9chat.useFloatingBtn = f9chat.chatScript?.dataset.floatingBtn === "true";

    // textContent may contain more than just the email (e.g. a name alongside it)
    const userDetailsText = f9chat.userDetails?.textContent;
    f9chat.userEmail =
      userDetailsText?.match(EMAIL_PATTERN)?.[0] ?? f9chat.userEmail;
    f9chat.collectEmail = !(f9chat.userDetails && f9chat.userEmail);

    // set domain value and profile if not in locahost development
    if (!window.location.hostname.includes("localhost")) {
      // all subdomains we need to remove
      const removeSubdomain = /((dl|ml)?(www|www1|shop|cart|store))\./;
      // all subdomains we need to remove the dl/ml prefix
      const removePrefix =
        /((dl|ml)?(login|course|fusion|home|myaccount|verify|help))\./;

      // set domain value after cleaning it up
      f9chat.domain = window.location.hostname.replace(removeSubdomain, "");
      f9chat.domain = removePrefix.test(f9chat.domain)
        ? f9chat.domain.replace(/(dl|ml)/, "")
        : f9chat.domain;

      // set chat profile to use for initialization
      const chatProfile = chatProfiles.find((profile) =>
        profile.domains?.includes(f9chat.domain),
      );
      f9chat.profile = chatProfile ? chatProfile.profile : f9chat.profile;
    }

    // used for testing localhost, you can set the profile you want to test
    // comment out below code after testing
    // f9chat.domain = 'certus.com';
    // f9chat.profile = 'VIVR';
    // end code for testing

    // if profile is VIVR then use prechat form
    f9chat.usePreChatForm = f9chat.profile === "VIVR";

    // creating chat container div and CSS
    const { container, style } = createChatContainer({
      id: "chatWidgetContainer",
      className: "chat-container",
      innerHTML: f9chat.usePreChatForm
        ? preFive9ChatFormHtml(f9chat.userEmail)
        : chatToggleButtonHtml,
      styleId: "chat-widget-style",
      styleContent: chatContainerCss,
    });

    // setting prechat form element
    f9chat.preChatForm = document.getElementById("pre-chat-form");

    f9chat.chatContainer = container;
    f9chat.chatWidgetStyle = style;
    f9chat.chatToggleButton =
      f9chat.chatContainer.querySelector(".chat-toggle-btn");

    // if we're re-initializing into an already-active five9 session (e.g. after a
    // page refresh), the SDK resumes the conversation instead of re-firing
    // ChatSystemConversationCreated, so the toggle button never gets its d-none
    // class re-applied by that event handler alone - set it directly from the
    // session flag we already track
    if (sessionStorage.getItem("activeChatSession") === "five9") {
      f9chat.chatToggleButton?.classList.add("d-none");
    }

    bindOnce(f9chat.chatToggleButton, "click", f9chat.hideChatWindow);
    f9chat.appendFloatingChatBtn();

    if (f9chat.useFloatingBtn) {
      console.log("Using Floating Button");
      f9chat.hideChatWindow();
    }
  },

  // mounting floating livechat button
  appendFloatingChatBtn: () => {
    let btnContainer = document.querySelector(".chat-floating-btn-container");
    if (!btnContainer) {
      btnContainer = document.createElement("div");
      btnContainer.setAttribute("class", "chat-floating-btn-container");
      btnContainer.innerHTML = floatingChatBtnHtml;
      document.body.appendChild(btnContainer);
    }
    f9chat.chatFloatingBtnContainer = btnContainer;
    bindOnce(
      btnContainer.querySelector(".chat-floating-btn"),
      "click",
      f9chat.startChat,
    );
  },

  showChatWindow: () => {
    console.log("Showing Five9 Chat Window!");

    f9chat.chatContainer.classList.add("is--visible");
    f9chat.chatFloatingBtnContainer.classList.remove("is--visible");
  },

  hideChatWindow: () => {
    console.log("Hiding Five9 Chat Window!");

    if (bChat.activeChatRoute === "five9") {
      f9chat.chatContainer.classList.remove("is--visible");
      f9chat.chatFloatingBtnContainer.classList.remove("is--visible");

      f9chat.destroyChatWindow();

      // show bChat's floating button if there is an active bChat session
      bChat.activeChatRoute = null;
      bChat.init();
      bChat.hideChatWindow();

      return;
    }

    f9chat.chatContainer.classList.remove("is--visible");
    f9chat.chatFloatingBtnContainer.classList.add("is--visible");
  },

  initChat: () => {
    // workaround for initializing the chat on demand
    // instead of loading the script via a script tag, we fetch the script and use the JS inside an inline script tag
    // this ensure that we only trigger the initialization when the base script is loaded/ready

    fetch(CHAT_CONFIG.five9.scriptUrl)
      .then((res) => {
        if (!res.ok) {
          console.error(`Can't fetch Five9 script, status code: ${res.status}`);
          return null;
        }
        return res.text();
      })
      // only initialize the chat when the main chat script is fetched
      .then((script) => {
        if (!script) return; // fetch failed above, nothing to initialize

        if (!document.getElementById("five9-chat-script")) {
          (function injectScript() {
            const el = document.createElement("script");
            el.id = "five9-chat-script";
            el.type = "text/javascript";
            el.innerHTML = script;
            const scripts = document.getElementsByTagName("script");
            const lastScript = scripts[scripts.length - 1];
            lastScript.parentNode.insertBefore(el, lastScript);
          })();
        }

        f9chat.showChatWindow();

        // this is the modified version of initialization config from Five9
        // F9.Chat.Wrapper.init should be called only after the main script is loaded
        F9.Chat.Wrapper.init({
          cdn: "prod",
          useBusinessHours: true,
          languages: {
            enabled: true,
            backgroundColor: "#65758e",
            defaultToBrowserLocale: true,
            allowUnconfiguredLanguages: false,
            languages: [
              {
                label: "English",
                code: "en",
                typeLang: "preferred",
                default: true,
              },
              {
                label: "Spanish",
                code: "es",
                typeLang: "additional",
                default: false,
              },
            ],
          },
          l10n: {
            en: {
              messenger: { customText: {} },
              systemMessages: {
                transferredToParticipant:
                  "The chat has been transferred to {name}.",
                transferredToGroup:
                  "That chat has been transferred to group {group}.",
              },
              captureFields: captureFields("en", f9chat.collectEmail),
            },
            es: {
              messenger: { customText: { ...messagerCustomText.es } },
              systemMessages: { ...systemMessages.es },
              captureFields: captureFields("es", f9chat.collectEmail),
            },
          },
          prepopulatedFields: [
            { k: "campaign", v: f9chat.profile },
            { k: "Chat.domain", v: f9chat.domain },
            { k: "GroupId", v: f9chat.readCookie("_up4gid") },
            { k: "CouponCode", v: f9chat.readCookie("_up4cc") },
            ...(!f9chat.collectEmail
              ? [{ k: "email", v: f9chat.userEmail }]
              : []), // use email value from page
          ],
          messenger: {
            integrationId: "667f3a8d5d880336c8c69068",
            soundNotificationEnabled: true,
            transcriptPrintingEnabled: false,
            menuItems: {
              imageUpload: true,
              fileUpload: true,
              shareLocation: false,
            },
            embedded: true,
            setViewportScale: false,
            containerId: "chatWidgetContainer", // container div for embedded chat
            browserStorage: "sessionStorage",
            hideWidgetAfterBusinessHours: false,
            scheduleCallback: {
              isCallbackEnabled: false,
              requestCallbackList: "",
              customConfirmationMessage:
                "We will call you as soon as we can at [PHONE]",
              web2CampaignAPIHost: "",
            },
            fixedHeader: true,
            displayStyle: "embedded",
            customColors: {
              brandColor: "65758e",
              conversationColor: "0099ff",
              actionColor: "0099ff",
            },
            carouselType: "default",
            // customCssUrl: 'https://cdn.certus.com/global/css/five9.css', // if we need custom CSS
          },
          clearMessagesTimeout: 3,
        });

        // this is the event that should trigger setting a session flag that we can check if there is an active chat session
        F9.Chat.Wrapper.messenger.on(
          F9.Chat.Wrapper.Events.ChatCaptureSubmitted,
          () => {
            console.log("ChatCaptureSubmitted event received");
            sessionStorage.setItem("activeChatSession", "five9");
          },
        );

        F9.Chat.Wrapper.messenger.on(
          F9.Chat.Wrapper.Events.ChatMessageReceived,
          () => {
            console.log("ChatMessageReceived event received");
          },
        );

        F9.Chat.Wrapper.messenger.on(
          F9.Chat.Wrapper.Events.ChatSystemConversationCreated,
          () => {
            console.log("ChatSystemConversationCreated event received");
            // hide the chat toggle button
            f9chat.chatToggleButton?.classList.add("d-none");

            sessionStorage.setItem("activeChatSession", "five9");
          },
        );

        // this is the event that should trigger clearing the session flag that we use to check if there is an active chat session
        F9.Chat.Wrapper.messenger.on(
          F9.Chat.Wrapper.Events.ChatSystemConversationTerminated,
          () => {
            console.log("ChatSystemConversationTerminated event received");
            // show the chat toggle button again
            f9chat.chatToggleButton?.classList.remove("d-none");

            sessionStorage.removeItem("activeChatSession");

            // collapse chat window, remove the container/floating button/style,
            // and reset the initialized flag (all handled by destroyChatWindow)
            f9chat.hideChatWindow();
            f9chat.destroyChatWindow();

            // removing prechat container with prechat form before showing bifurcated chat window
            bChat.destroyPreChatWindow();

            // reinitialize bifurcated chat since active Five9 chat session has ended
            bChat.init();
          },
        );
      })
      .catch((err) => {
        console.error("Error: " + err);
      });
  },

  initVIVR: () => {
    if (!f9chat.isPreChatValid(f9chat.preChatForm)) {
      // dont initializing chat if it has been initialized before
      console.log("Prechat form is missing information.");
      return;
    }

    // console.log('Prechat form is valid...');

    const preChatForm = getFormDataObject(f9chat.preChatForm);
    f9chat.userEmail = preChatForm.email;

    const vivrURL = `${CHAT_CONFIG.five9.vivrBaseUrl}?form_domain=${f9chat.domain}&form_email=${encodeURIComponent(
      preChatForm.email,
    )}&form_userAgent=${encodeURIComponent(navigator.userAgent)}&form_language=${encodeURIComponent(
      preChatForm.language,
    )}&__CALLBACK_URL__=${CHAT_CONFIG.five9.callbackUrl}`;

    // show VIVR iframe
    const vivrIframe = document.getElementById("vivr-iframe");
    const preChatWrap = document.getElementById("pre-chat-form-wrapper");
    vivrIframe.onload = () => {
      // Set a delay (e.g., 2000 milliseconds = 2 seconds)
      setTimeout(() => {
        vivrIframe.style.display = "block";
      }, 2000);
    };
    preChatWrap.style.display = "none";
    vivrIframe.src = vivrURL;

    // handle messages from the chat iframe when VIVR is used
    if (!window.__f9ChatListenerAttached) {
      window.__f9ChatListenerAttached = true;

      window.addEventListener("message", (event) => {
        if (event.data?.source !== "five9-chat-proxy") return;

        if (event.data.event === "ChatCaptureSubmitted") {
          console.log(
            "ChatCaptureSubmitted received on parent:",
            event.data.data,
          );
          sessionStorage.setItem("activeChatSession", "five9");
        }

        if (event.data.event === "ChatMessageReceived") {
          console.log(
            "ChatMessageReceived received on parent:",
            event.data.data,
          );
        }

        if (event.data.event === "ChatSystemConversationCreated") {
          console.log(
            "ChatSystemConversationCreated received on parent:",
            event.data.data,
          );
          // hide the chat toggle button
          f9chat.chatToggleButton?.classList.add("d-none");

          sessionStorage.setItem("activeChatSession", "five9");
        }

        if (event.data.event === "ChatSystemConversationTerminated") {
          console.log(
            "ChatSystemConversationTerminated received on parent:",
            event.data.data,
          );
          // show the chat toggle button again
          f9chat.chatToggleButton?.classList.remove("d-none");

          sessionStorage.removeItem("activeChatSession");

          // collapse chat window, remove the container/floating button/style,
          // and reset the initialized flag (all handled by destroyChatWindow)
          f9chat.hideChatWindow();
          f9chat.destroyChatWindow();

          // removing prechat container with prechat form before showing bifurcated chat window
          bChat.destroyPreChatWindow();

          // reinitialize bifurcated chat since active Five9 chat session has ended
          bChat.init();
        }
      });
    }
  },

  startChat: () => {
    if (f9chat.chatInitialized) {
      f9chat.chatFloatingBtnContainer.classList.remove("is--visible");
      f9chat.chatContainer.classList.add("is--visible");

      // dont initializing chat if it has been initialized before
      return;
    }

    // use marketing website chat experience
    if (!f9chat.usePreChatForm) {
      // initialize and show chat widget
      f9chat.initChat();
    }
    // use VIVR experience and pre chat form
    else {
      f9chat.showChatWindow();

      // set eventListener for prechat submit button to initialize VIVR chat
      bindOnce(
        document.querySelector(".pre-chat-start-btn"),
        "click",
        f9chat.initVIVR,
      );

      f9chat.validateOnBlur(f9chat.preChatForm);
    }

    f9chat.chatInitialized = true;
  },

  destroyChatWindow: () => {
    // removing prechat container with prechat form before showing bifurcated chat window
    f9chat.chatContainer && f9chat.chatContainer.remove();
    f9chat.chatFloatingBtnContainer && f9chat.chatFloatingBtnContainer.remove();
    f9chat.chatWidgetStyle && f9chat.chatWidgetStyle.remove();

    f9chat.chatInitialized = false;
  },

  validateOnBlur: validateOnBlur,
  isPreChatValid: isPreChatValid,

  readCookie: (name) => {
    const nameEQ = `${encodeURI(name)}=`;
    const cookies = document.cookie.split(";");
    for (const cookie of cookies) {
      const trimmed = cookie.trimStart();
      if (trimmed.indexOf(nameEQ) === 0) {
        return decodeURI(trimmed.substring(nameEQ.length));
      }
    }
    return null;
  },
};

const bChat = {
  chatScript: document.getElementById("bifurcated_chat"),
  preChatForm: null,
  preChatInitialized: false,
  useFloatingBtn: false,
  preChatContainer: null,
  chatFloatingBtnContainer: null,
  chatWidgetStyle: null,
  activeChatRoute: null, // liveHelpNow/five9 depending on the prechat form selection
  liveHelpChatInitialized: false,

  init: () => {
    // if there is an active Five9 session intialize the Five9 chat
    if (sessionStorage.getItem("activeChatSession") === "five9") {
      f9chat.init();

      return;
    }

    // if there is an active Live Help Now session intialize the Live Help Now chat
    if (sessionStorage.getItem("activeChatSession") === "liveHelpNow") {
      bChat.initLiveHelpNow();

      return;
    }

    // initialize prechat form to determine which chat is used, either Five9 or Live Help Now
    bChat.useFloatingBtn = bChat.chatScript?.dataset.floatingBtn === "true";

    // creating chat container div and CSS
    const { container, style } = createChatContainer({
      id: "bChatWidgetContainer",
      className: "chat-container",
      innerHTML: preBifurcatedChatFormHtml,
      styleId: "chat-widget-style",
      styleContent: chatContainerCss,
    });

    // setting prechat form element
    bChat.preChatForm = document.getElementById("pre-chat-form");

    bChat.preChatContainer = container;
    bChat.chatWidgetStyle = style;
    bindOnce(
      bChat.preChatContainer.querySelector(".chat-toggle-btn"),
      "click",
      bChat.hideChatWindow,
    );

    bChat.appendFloatingChatBtn();

    if (bChat.useFloatingBtn) {
      console.log("Using Floating Button");
      bChat.hideChatWindow();
    }

    if (!bChat.preChatInitialized) {
      // set eventListener for prechat submit button to initialize VIVR chat
      bindOnce(
        document.querySelector(".pre-chat-start-btn"),
        "click",
        bChat.bifurcateChat,
      );

      bChat.validateOnBlur(bChat.preChatForm);

      bChat.preChatInitialized = true;
    }
  },

  // mounting floating livechat button
  appendFloatingChatBtn: () => {
    let btnContainer = document.querySelector(".chat-floating-btn-container");
    if (!btnContainer) {
      btnContainer = document.createElement("div");
      btnContainer.setAttribute("class", "chat-floating-btn-container");
      btnContainer.innerHTML = floatingChatBtnHtml;
      document.body.appendChild(btnContainer);
    }
    bChat.chatFloatingBtnContainer = btnContainer;
    bindOnce(
      btnContainer.querySelector(".chat-floating-btn"),
      "click",
      bChat.showChatWindow,
    );
  },

  // this needs to account for active sessions as well as the bifurcation logic to determine which chat to initialize and show
  showChatWindow: () => {
    console.log("Showing Chat Window!");

    if (sessionStorage.getItem("activeChatSession") === "five9") {
      // if there is an active Five9 session show the Five9 chat window instead of the prechat form
      // f9chat.initChat();
      f9chat.startChat();

      // removing prechat container with prechat form before showing bifurcated chat window
      bChat.destroyPreChatWindow();

      return;
    }

    if (
      sessionStorage.getItem("activeChatSession") === "liveHelpNow" ||
      bChat.liveHelpChatInitialized
    ) {
      // we assume that the Live Help Now chat is already initialized so we can just who the chat window
      lhnJsSdk.openHOC();

      // removing prechat container with prechat form before showing bifurcated chat window
      bChat.destroyPreChatWindow();

      return;
    }

    bChat.preChatContainer.classList.add("is--visible");
    bChat.chatFloatingBtnContainer.classList.remove("is--visible");

    // show Five9 chat window if there is an active session
    if (bChat.activeChatRoute === "five9") {
      f9chat.showChatWindow();
    }

    // show Live Help Now chat window if there is an active session
    if (bChat.activeChatRoute === "liveHelpNow") {
      bChat.initLiveHelpNow();
    }
  },

  hideChatWindow: () => {
    console.log("Hiding Chat Window!");

    bChat.preChatContainer.classList.remove("is--visible");
    bChat.chatFloatingBtnContainer.classList.add("is--visible");
  },

  initLiveHelpNow: () => {
    const sdkLoaded = typeof window.lhnJsSdk === "object";

    if (sdkLoaded && window.islhnJsSdkReady === true) {
      document
        .querySelectorAll("#lhnHelpOutCenter, #lhnHocButton")
        ?.forEach((el) => (el.style.display = "block"));

      bChat.liveHelpChatInitialized = true;
      lhnJsSdk.openHOC();

      // removing prechat container with prechat form before showing bifurcated chat window
      bChat.destroyPreChatWindow();
      return;
    }

    window.lhnJsSdkReady = function () {
      console.log("LiveHelpNow Chat is ready");

      lhnJsSdk.openHOC();

      bChat.liveHelpChatInitialized = true;

      window.islhnJsSdkReady = true;

      // removing prechat container with prechat form before showing bifurcated chat window
      bChat.destroyPreChatWindow();
    };

    window.lhnJsSdkPreChatSubmitted = function () {
      console.log("LiveHelpNow Pre-chat form submitted");
      sessionStorage.setItem("activeChatSession", "liveHelpNow");
    };

    window.lhnJsSdkChatStarted = function () {
      console.log("LiveHelpNow Chat started");
      sessionStorage.setItem("activeChatSession", "liveHelpNow");
    };

    window.lhnJsSdkBotInputReceived = function (question, answer) {
      console.log("LiveHelpNow Chat started", { question, answer });
      sessionStorage.setItem("activeChatSession", "liveHelpNow");
    };

    window.lhnJsSdkInviteAccepted = function () {
      console.log("LiveHelpNow chat invite accepted");

      // hidding prechat form and floating button when chat invite is accepted and chat window is opened
      bChat.hideChatWindow();
      bChat.chatFloatingBtnContainer.classList.remove("is--visible");

      document
        .querySelectorAll("#lhnHelpOutCenter, #lhnHocButton")
        ?.forEach((el) => (el.style.display = "block"));

      lhnJsSdk.openHOC();

      bChat.activeChatRoute = "liveHelpNow";
    };

    window.lhnJsSdkChatEnded = function (chat_session_id) {
      console.log("LiveHelpNow Chat ended", { chat_session_id });
      sessionStorage.removeItem("activeChatSession");

      // removing live help DOM elements after chat ends
      document
        .querySelectorAll("#lhnHelpOutCenter, #lhnHocButton")
        ?.forEach((el) => (el.style.display = "none"));

      bChat.liveHelpChatInitialized = false;
      bChat.activeChatRoute = null;

      // reinitialize bifurcated chat since chat session has ended
      bChat.init();
    };

    window.lhnJsSdkEmbeddedClosed = function () {
      console.log("LiveHelpNow Pre-chat window closed");

      if (sessionStorage.getItem("activeChatSession") !== "liveHelpNow") {
        // removing live help DOM elements after chat ends
        document
          .querySelectorAll("#lhnHelpOutCenter, #lhnHocButton")
          ?.forEach((el) => (el.style.display = "none"));

        bChat.liveHelpChatInitialized = false;
        bChat.activeChatRoute = null;

        if (!bChat.preChatInitialized) {
          bChat.init();
        }

        bChat.chatFloatingBtnContainer.classList.add("is--visible");
      }
    };

    window.lhnJsSdkInit = function () {
      lhnJsSdk.setup = {
        application_id: "a2128cb4-c254-4746-bc99-fc56fe029079",
        application_secret:
          "6e54f2f326144411a1d36791ebe936f9c93f09648fb94ff1a5",
      };
      lhnJsSdk.controls = [
        {
          type: "hoc",
          id: bChat.chatScript?.dataset.liveHelpId || null, // this value is dynamic and will be passed via data attribute in the script tag, this is the ID for the specific chat widget in Live Help Now that we want to load
        },
      ];
    };

    (function (d, s) {
      var newjs,
        lhnjs = d.getElementsByTagName(s)[0];
      newjs = d.createElement(s);
      newjs.src =
        "https://developer.livehelpnow.net/js/sdk/lhn-jssdk-current.min.js";
      lhnjs.parentNode.insertBefore(newjs, lhnjs);
    })(document, "script");

    // adding CSS for live help chat
    (function () {
      const liveHelpChatCssAdded = document.getElementById(
        "live-help-chat-style",
      );
      if (liveHelpChatCssAdded) {
        return;
      }
      const style = document.createElement("style");
      style.id = "live-help-chat-style";
      style.innerHTML = liveHelpChatCss;
      document.body.appendChild(style);
    })();
  },

  destroyPreChatWindow: () => {
    // removing prechat container with prechat form before showing bifurcated chat window
    bChat.preChatContainer && bChat.preChatContainer.remove();
    bChat.chatFloatingBtnContainer && bChat.chatFloatingBtnContainer.remove();
    bChat.chatWidgetStyle && bChat.chatWidgetStyle.remove();

    bChat.preChatInitialized = false;
  },

  bifurcateChat: () => {
    if (!bChat.isPreChatValid(bChat.preChatForm)) {
      console.log("Prechat form is missing information.");
      return;
    }

    console.log("Prechat form is valid...");

    const preChatForm = getFormDataObject(bChat.preChatForm);
    if (preChatForm.chatRoute === "support") {
      bChat.destroyPreChatWindow();
      f9chat.init();
      f9chat.startChat();
      bChat.activeChatRoute = "five9";
    } else if (preChatForm.chatRoute === "sales") {
      bChat.initLiveHelpNow();
      bChat.activeChatRoute = "liveHelpNow";
    }
  },

  validateOnBlur: validateOnBlur,
  isPreChatValid: isPreChatValid,
};

bChat.init();

// show chat window for testing and development, comment this out for production
// bChat.showChatWindow();

// need to call this after the main JS is loaded on the page
// this function is what the website is calling
const StartLiveChat = () => {
  // f9chat.startChat();
  bChat.showChatWindow();
};
